import profile from './profile.schema';
import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Profil',
  type: 'object',
  properties: {
    ...profile.properties,
    repeatEmail: {
      ...profile.properties.email,
      title: 'Powtórz adres e-mail',
      computed: true,
      validFunc: '$value === this.email',
      validationMessages: {
        validFunc: 'Adresy e-mail muszą być takie same.'
      }
    }
  },
  allOf: [validationMessages]
};
